import { render } from "./EnterForm.vue?vue&type=template&id=76c81ac6"
import script from "./EnterForm.vue?vue&type=script&lang=ts"
export * from "./EnterForm.vue?vue&type=script&lang=ts"
script.render = render

export default script